/** Empty cell wypełniający kolumnę gridu. Bez danych, bez interakcji. */
export function SpacerRow() {
  return <div aria-hidden />
}
